/* eslint-disable */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Ico } from './ShellIcons';
import fb from './filterBar.module.css';
import pop from './popovers.module.css';

// ============================================================
// FilterField — one multi-select filter: the pill (label → LABEL + value when
// on) and its popover (search when long, tick rows with Only, Clear · Done).
// Options: [{ value, label?, count?, color? }]. value: a Set of option values.
// `single: true` makes it one-of (a Sales server filter takes one value): a
// tick replaces the choice, a second tick on it clears, no "Only".
// ============================================================

const fmt = (n) => (n == null ? '' : Number(n).toLocaleString('en-US'));
export const optLabel = (o) => (o.label != null ? String(o.label) : String(o.value));

export function fieldSummary(options, value) {
  if (!value || value.size === 0) return '';
  const names = [];
  for (const v of value) { const o = options.find((x) => x.value === v); names.push(o ? optLabel(o).split(' — ')[0] : String(v)); }
  return names.length === 1 ? names[0] : `${names[0]} +${names.length - 1}`;
}

export function OptionRows({ field, onChange, listRef }) {
  const value = field.value || new Set();
  const [q, setQ] = useState('');
  const searchable = field.searchable != null ? field.searchable : field.options.length > 6;
  const rows = useMemo(() => {
    const t = q.trim().toLowerCase();
    return t ? field.options.filter((o) => optLabel(o).toLowerCase().includes(t)) : field.options;
  }, [field.options, q]);
  const toggle = (v) => { if (field.single) { onChange(value.has(v) ? new Set() : new Set([v])); return; } const n = new Set(value); n.has(v) ? n.delete(v) : n.add(v); onChange(n); };
  const only = (v) => onChange(new Set([v]));
  const onKey = (e) => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    const btns = Array.from(e.currentTarget.querySelectorAll('button'));
    const i = btns.indexOf(document.activeElement);
    const n = e.key === 'ArrowDown' ? Math.min(btns.length - 1, i + 1) : Math.max(0, i - 1);
    btns[n] && btns[n].focus(); e.preventDefault();
  };
  return (
    <>
      {searchable && (
        <div className={pop.fs}><Ico name="search" /><input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder={`Find ${field.label.toLowerCase()}…`} aria-label={`Find ${field.label}`} /></div>
      )}
      <div className={pop.fpList} ref={listRef} onKeyDown={onKey} role="listbox" aria-multiselectable={field.single ? "false" : "true"}>
        {rows.length === 0 && <div className={pop.fempty}>Nothing matches “{q}”</div>}
        {rows.map((o) => {
          const on = value.has(o.value);
          return (
            <button key={String(o.value)} type="button" role="option" aria-selected={on} className={`${pop.fo} ${on ? pop.on : ''}`} onClick={() => toggle(o.value)}>
              <span className={pop.ck}><Ico name="check" /></span>
              {o.color && <span className={pop.sw} style={{ background: o.color }} />}
              <span className={pop.t}>{optLabel(o)}</span>
              {!field.single && <span className={pop.only} role="button" tabIndex={-1} onClick={(e) => { e.stopPropagation(); only(o.value); }}>Only</span>}
              {o.count != null && <span className={pop.k}>{fmt(o.count)}</span>}
            </button>
          );
        })}
      </div>
    </>
  );
}

export default function FilterField({ field, open, onToggle, onClose, align = 'left' }) {
  const value = field.value || new Set();
  const on = value.size > 0;
  const listRef = useRef(null);
  const summary = fieldSummary(field.options, value);
  useEffect(() => { if (open && listRef.current && !field.options.length) onClose(); }, [open]);
  return (
    <div className={`${fb.ffw}`} data-ffw="list" data-prio={field.priority || 1}>
      <button type="button" className={`${fb.ff} ${on ? fb.on : ''} ${open ? fb.open : ''}`} onClick={(e) => { e.stopPropagation(); onToggle(); }} aria-expanded={open} aria-haspopup="listbox" title={field.title || field.label}>
        <span className={fb.fl}>{field.label}</span>
        <span className={fb.fv}>{summary}</span>
        <span className={`${fb.fn} ${value.size > 1 ? fb.show : ''}`}>{value.size}</span>
        <Ico name="chev" className={fb.chev} />
      </button>
      {open && (
        <div className={`${pop.fpop} ${align === 'right' ? pop.right : ''}`} data-shell-pop onClick={(e) => e.stopPropagation()}>
          <div className={pop.fpHead}><span className={pop.fpT}>{field.label}</span><span className={pop.fpN}>{field.options.length} options{on ? <> · <b>{value.size} on</b></> : null}</span></div>
          <OptionRows field={field} onChange={field.onChange} listRef={listRef} />
          <div className={pop.ffoot}>
            <button type="button" onClick={() => field.onChange(new Set())}>Clear</button>
            <span className={pop.fpHint}><kbd>↑↓</kbd> move · <kbd>space</kbd> {field.single ? 'pick' : 'tick'}</span>
            <button type="button" className={pop.go} onClick={onClose}>Done</button>
          </div>
        </div>
      )}
    </div>
  );
}
